const e = "pagination-change", t = class t extends CustomEvent {
  constructor(o, s, n) {
    super(e, { detail: { page: o, pageButton: s }, bubbles: !0, composed: !0 }), this.originalEvent = n;
  }
  preventDefault() {
    super.preventDefault(), this.originalEvent.preventDefault();
  }
  stopPropagation() {
    super.stopPropagation(), this.originalEvent.stopPropagation();
  }
};
t.EVENT_NAME = e;
let a = t;
export {
  e as EVENT_NAME,
  a as default
};
//# sourceMappingURL=PaginationChangeEvent.js.map
